import * as actionTypes from 'actions';
import { PORTAL_USER_ROLES } from 'common/constants';

const initialState = {
  saved: false,
  savedPortalUser: {},
  deleted: false,
  deletedPortalUser: {},
  portalUser: {
    creationId: null,
    name: '',
    emailAddress: '',
    customers: [],
    roles: ['STAFF'],
    sendWelcomeEmail: true
  },
  customers: [],
  validationMessages: {}
};

const portalUserCreateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_PORTAL_USER_FULFILLED: {
      return {
        ...state,
        saved: action.payload.data.success,
        savedParticipant: action.payload.data.result,
        validationMessages: action.payload.data.validationMessages
      };
    }

    case actionTypes.DELETE_PORTAL_USER_FULFILLED: {
      return {
        ...state,
        deleted: action.payload.data.success,
        deletedParticipant: action.payload.data.result
      };
    }

    case actionTypes.EDIT_PORTAL_USER_FULFILLED: {
      return {
        ...state,
        portalUser: {
          ...action.payload.data.result,
          identifiersCreated: true
        }
      };
    }

    case actionTypes.CREATE_PORTAL_USER_VALUE_RESET: {
      return {
        ...initialState
      };
    }

    case actionTypes.CREATE_PORTAL_USER_VALUE_UPDATE: {
      return {
        ...state,
        portalUser: {
          ...state.portalUser,
          ...action.payload
        }
      };
    }

    case actionTypes.SET_PORTAL_USER_ROLE: {
      const { role, roleGroup } = action.payload;

      // If this is an optional roleGroup, deselect the clicked role (if index > -1)

      const roles = state.portalUser.roles
        ? state.portalUser.roles.slice()
        : [];

      const roleIndex = roles.indexOf(role);
      const roleAlreadyAssociated = roleIndex > -1;

      // If role already exists, then remove. Regardless.
      if (roleIndex > -1) {
        roles.splice(roleIndex, 1);
      }

      if (roleGroup !== 'General Access') {
        // Role groups other than General access can only have one active role per group

        if (!roleAlreadyAssociated) {
          for (let i = 0; i < roles.length; i++) {
            const r = roles[i];
            if (PORTAL_USER_ROLES[r].roleGroup == roleGroup) {
              roles.splice(i, 1);
            }
          }

          roles.push(role);
        }
      } else {
        if (!roleAlreadyAssociated) {
          roles.push(role);
        }
      }

      return {
        ...state,
        portalUser: {
          ...state.portalUser,
          roles: roles
        }
      };
    }

    case actionTypes.FIND_CUSTOMERS_PENDING: {
      return {
        ...state,
        customers: initialState.customers
      };
    }

    case actionTypes.FIND_CUSTOMERS_FULFILLED: {
      return {
        ...state,
        customers: action.payload.data
      };
    }

    default: {
      return state;
    }
  }
};

export default portalUserCreateReducer;
